/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BaseCostProcessingMemory {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return BaseCostProcessingMemory.fixupPrototype; }

    static newInstance(model: Partial<BaseCostProcessingMemory>): BaseCostProcessingMemory {
        let obj = Object.assign(new BaseCostProcessingMemory(), model);
        BaseCostProcessingMemory.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BaseCostProcessingMemory>): BaseCostProcessingMemory {
        if (!model) return null;
        return BaseCostProcessingMemory.newInstance(<BaseCostProcessingMemory> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BaseCostProcessingMemory) {
        if (!obj) return;

        models.BaseCostProcessingMemory.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BaseCostProcessingMemory): boolean {
        switch (obj.__type)
        {
            case "CostProcessingMemoryForAnthropicPlatform":
                Object.setPrototypeOf(obj, models.CostProcessingMemoryForAnthropicPlatform.prototype);
                break;
            case "CostProcessingMemoryForAws":
                Object.setPrototypeOf(obj, models.CostProcessingMemoryForAws.prototype);
                break;
            case "CostProcessingMemoryForAzure":
                Object.setPrototypeOf(obj, models.CostProcessingMemoryForAzure.prototype);
                break;
            case "CostProcessingMemoryForAzureAi":
                Object.setPrototypeOf(obj, models.CostProcessingMemoryForAzureAi.prototype);
                break;
            case "CostProcessingMemoryForAzureCsp":
                Object.setPrototypeOf(obj, models.CostProcessingMemoryForAzureCsp.prototype);
                break;
            case "CostProcessingMemoryForAzureEa":
                Object.setPrototypeOf(obj, models.CostProcessingMemoryForAzureEa.prototype);
                break;
            case "CostProcessingMemoryForAzureMca":
                Object.setPrototypeOf(obj, models.CostProcessingMemoryForAzureMca.prototype);
                break;
            case "CostProcessingMemoryForGcp":
                Object.setPrototypeOf(obj, models.CostProcessingMemoryForGcp.prototype);
                break;
            case "CostProcessingMemoryForKubernetesAgent":
                Object.setPrototypeOf(obj, models.CostProcessingMemoryForKubernetesAgent.prototype);
                break;
            case "CostProcessingMemoryForOci":
                Object.setPrototypeOf(obj, models.CostProcessingMemoryForOci.prototype);
                break;
            case "CostProcessingMemoryForSaas":
                Object.setPrototypeOf(obj, models.CostProcessingMemoryForSaas.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof BaseCostProcessingMemory)[] {
        return [
            models.CostProcessingMemoryForAnthropicPlatform,
            models.CostProcessingMemoryForAws,
            models.CostProcessingMemoryForAzure,
            models.CostProcessingMemoryForAzureAi,
            models.CostProcessingMemoryForAzureCsp,
            models.CostProcessingMemoryForAzureEa,
            models.CostProcessingMemoryForAzureMca,
            models.CostProcessingMemoryForGcp,
            models.CostProcessingMemoryForKubernetesAgent,
            models.CostProcessingMemoryForOci,
            models.CostProcessingMemoryForSaas,
        ];
    }

    fixupFields() {
        if (this.schema === undefined) {
            this.schema = 0;
        }
    }

    /**
     * Schema version
     */
    schema: number;

    /**
     * List of skipped tag keys
     */
    skipped_tags: Array<string>;

}
